// src/components/Login.js
import React, { useState } from 'react';
import axios, { setAuthToken } from '../utils/axiosInstance';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await axios.post('/auth/login', form);
      const { token, user } = res.data;

      // persist + immediately attach to axios for this tab
      localStorage.setItem('token', token);
      localStorage.setItem('isAdmin', user.isAdmin ? 'true' : 'false');
      localStorage.setItem('username', user.username);
      setAuthToken(token);

      // Redirect based on role (👈 updated)
      navigate(user.isAdmin ? '/admin/lists' : '/rank-me');
    } catch (err) {
      console.error('Login failed:', err);
      const msg =
        err?.response?.status === 401
          ? '❌ Invalid username or password.'
          : '❌ Login failed. Please try again.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page-container">
      <h1 className="auth-heading">Welcome to Rankr</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <input
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleChange}
          required
        />
        <input
          name="password"
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={submitting}>
          {submitting ? 'Logging in…' : 'Login'}
        </button>
        {error && <p style={{ color: 'red', marginTop: 8 }}>{error}</p>}
      </form>
    </div>
  );
};

export default Login;
